import { asApiFailure } from "@utils/apiFailure";

// The complete-signup POST fails in three shapes the landing page must tell
// apart, because each drives a different UI transition:
//   - 409  the email is already registered → contact us (OB-03), or sign in
//          if the account is their own
//   - 404/410  the token is now invalid/expired/consumed → show the invalid state
//   - anything else → a generic inline retry message
export type CompleteInvitationFailure =
    | "already-registered"
    | "invalid-token"
    | "generic";

// The status is read through the shared asApiFailure, which duck-types the
// ApiError useApi throws, so this helper stays free of the useApi module's
// config/MSAL imports and is trivially unit-testable.
export const completeInvitationOutcome = (
    error: unknown,
): CompleteInvitationFailure => {
    switch (asApiFailure(error)?.status) {
        case 409:
            return "already-registered";
        case 404:
        case 410:
            return "invalid-token";
        default:
            return "generic";
    }
};
